import { render, staticRenderFns } from "./D4DNavigation.vue?vue&type=template&id=236a5988&scoped=true&"
import script from "./D4DNavigation.vue?vue&type=script&lang=js&"
export * from "./D4DNavigation.vue?vue&type=script&lang=js&"
import style0 from "./D4DNavigation.vue?vue&type=style&index=0&id=236a5988&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a5988",
  null
  
)

export default component.exports